import React, { useEffect, useState } from "react";
import MapComponent from "../../../Components/Maps/MapComponent";

const MapaLogisticoTab = (props: any) => {
	async function atualizaListaBuscaCallBack(pageSize:number, pageNumber:number)
	{
		//let response: any = await axios.get(`buscaDadosGridEmViagem?page=${pageNumber}&pageSize=${pageSize}`);
		let response: any = {data: { data: [], total: 0 } };
		props.setLabel(`Mapa Logístico (${response.data.total})`);
	}

	return (
		<div className="col-md-12" style={{height: '100%'}}>
			<MapComponent height={((window.innerHeight) - 140)} />
		</div>
	);
}

export default MapaLogisticoTab;